// extracted by mini-css-extract-plugin
export default {"basketBarHeight":"4rem","pageContainer":"G29fbf9","footerWrap":"G6e6d24","pullUp":"G2fb1fb","withBottomBar":"Gddbaa4"};